module.exports = __webpack_public_path__ + "static/media/Vampire.46c8ab3f.jpg";